import type React from 'react';

interface Props {
  title: string;
  children: any;
  className?: string;
}

export const WebclientInputGroup: React.FC<Props> = ({
  children,
  title,
  className = '',
}) => {
  return (
    <div className={`tailwind-section ${className}`}>
      <h5 className='!text-primary-base mb-3 text-lg'>{title}</h5>
      {children}
    </div>
  );
};

export default WebclientInputGroup;
